module.exports = __webpack_public_path__ + "static/media/deals.872ae217.png";